module.exports = __webpack_public_path__ + "img/catchup.a8a40b.svg";